import { Injectable } from '@angular/core';

import { StorageInterface } from './storage.interface';
import { StorageService } from './storage.service';

@Injectable({
    providedIn: 'root',
})
export class UniversalStorageService extends StorageService {
    // protected sessionStorageKeys: string[] = Object.keys(sessionStorage);
    protected localStorageKeys: string[] = Object.keys(localStorage);

    /**
     * Use item of StorageInterface insterad of simple key value to make storage expires
     * @param key
     * @param value
     * @param expires timestamp
     */
    public setItem(key: string, value: any, expires: number = null, preserveCompatibility: boolean = true) {
        const storageObject: StorageInterface = {
            data: value,
            expiresTimestamp: expires,
        };
        this.removeItem(key);
        this._getStorageInstance(key).setItem(
            this.prefix + key,
            JSON.stringify(preserveCompatibility ? value : storageObject),
        );
    }
}
